import { connect } from '@ardoq/rxbeach';
import { PropertiesEditor } from './PropertiesEditor';
import { propertiesEditor$ } from 'appModelStateEdit/propertiesEditor/propertiesEditor$';

export const PropertiesEditorConnected = connect(
  PropertiesEditor,
  propertiesEditor$
);
